<template>
	<panel-wrapper content-class="flex flex-col box-wap">
		<template slot="name">
			信号源列表
		</template>
		<div class="content-title">
	
				
		
		</div>
		<div
			v-if="currentScene"
			class="flex-grow button-grid has-per-row-1 overflow-y-auto box-wap-box"
		>
			
			
			<div
			v-for="source in currentScene.sources"
			:key="source.name"
			class="button buttonwap"
			:class="[source.render ? 'button-active' : '']"
			@click="setRender({scene: currentScene.name, source: source.name, render: !source.render})">
				
				<div>
					{{ source.name }}
				</div>
			</div>
			<div class="background-content" >
				<span><span v-if='showimgTitles'>信号源</span></br><span style="
				font-size: 26px;">{{ currentScene ? currentScene.name : '未知场景' }}</span></span>
			</div>
			
		</div>
		<div v-else>
			未知场景 :(
		</div>
	</panel-wrapper>
</template>

<script>
import {mapActions, mapGetters,mapState} from 'vuex'

import panelMixin from '@/mixins/panel'

export default {
	mixins: [panelMixin],
	computed: {
		...mapState(['showimgTitles']),
		...mapGetters('obs', ['currentScene'])
	},
	methods: {
		...mapActions({
			setRender: 'obs/sources/render'
		})
	}
}
</script>
<style type="text/css" scoped>
	.box-wap{
		border:1px solid #DCDFE6
	}
	 .el-button+.el-button{
		margin-top: 2px!important;
	}
	.scenes-name{
		font-size: 20px;
	}
</style>
